import { renderComponent } from 'utils/RenderingUtils';
import { IInputDataDesignerProps } from './DataDesigner';

export async function renderInputDataDesigner(props: IInputDataDesignerProps, callback?: () => void) {
  const container = document.createElement('div');
  container.className = 'data-designer-container';
  document.body.appendChild(container);
  const { DataDesigner } = await import('./DataDesigner');
  // we need to provide element to render element so we use the fake element which is not in the DOM

  return renderComponent({
    container: container,
    component: <DataDesigner {...props} />,
    callback,
    autoUnmount: true,
  });
}
